import { render, staticRenderFns } from "./Grouped.vue?vue&type=template&id=45bd3f87&scoped=true"
import script from "./Grouped.vue?vue&type=script&lang=js"
export * from "./Grouped.vue?vue&type=script&lang=js"
import style0 from "./Grouped.vue?vue&type=style&index=0&id=45bd3f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd3f87",
  null
  
)

export default component.exports